import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { FormGroup, ControlLabel } from 'react-bootstrap'
import { Row, Col } from 'react-flexbox-grid'

import RegistrationFilterTypes from '../../registration_filter_types'
import { GlgSelect } from 'SharedComponents'

class RegistrationFilter extends PureComponent {
  constructor(props) {
    super(props)
    this.onChange = props.onChange.bind(this, 'registration')
  }

  render() {
    let options = _.clone(OPTIONS)
    if (!this.props.showRegistrationOptions) {
      options = options.filter(option => (
        !REGISTRATION_OPTIONS_VALUES.includes(option.value)
      ))
    }
    if (!this.props.golfHubEnabled) {
      options = options.filter(option => (
        !GOLF_HUB_OPTIONS_VALUES.includes(option.value)
      ))
    }
    options = options.map(option => ({
      ...option,
      label: window.I18n.t(`customer_center_filters.components.filters.registration_filter.options.${option.value}`, {defaultValue: option.label}),
    }))

    const filterEventsText = (!window.I18n ? '' : window.I18n.t('customer_center_filters.components.filters.registration_filter.filter_events'))
    return (
      <FormGroup>
        <Row>
          <Col xs={true}>
            <ControlLabel className='add-margin-top-5'>
              { filterEventsText }
            </ControlLabel>
          </Col>
        </Row>
        <Row>
          <Col xs={true}>
            <GlgSelect items={ options }
                       value={ this.props.value }
                       onChange={ this.onChange }
                       disabled={ this.props.disabled }
                       isCustomized={ this.props.isCustomized } />
          </Col>
        </Row>
      </FormGroup>
    )
  }
}

RegistrationFilter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  showRegistrationOptions: PropTypes.bool,
  golfHubEnabled: PropTypes.bool,
  isCustomized: PropTypes.bool,
}

const OPTIONS = [
  {
    value: RegistrationFilterTypes.ALL,
    label: 'All',
  },
  {
    value: RegistrationFilterTypes.UPCOMING,
    label: 'Upcoming',
  },
  {
    value: RegistrationFilterTypes.PAST,
    label: 'Past',
  },
  {
    value: RegistrationFilterTypes.OPEN,
    label: 'Registration Open',
  },
  {
    value: RegistrationFilterTypes.WILL_OPEN,
    label: 'Registration Will Open',
  },
  {
    value: RegistrationFilterTypes.OPEN_FOR_INVITATION,
    label: 'Registration Open - Invitation List',
  },
  {
    value: RegistrationFilterTypes.OPEN_FOR_MEMBERSHIP,
    label: 'Registration Open - Membership Programs',
  },
  {
    value: RegistrationFilterTypes.CLOSED,
    label: 'Registration Closed',
  },
  {
    value: RegistrationFilterTypes.WAITLIST_NOT_EMPTY,
    label: 'Waitlist',
  },
  {
    value: RegistrationFilterTypes.PENDING_LIST_NOT_EMPTY,
    label: 'Pending Registration',
  },
  {
    value: RegistrationFilterTypes.NON_ARCHIVED,
    label: 'All Except Archived',
  },
  {
    value: RegistrationFilterTypes.GOLF_HUB_CREATED,
    label: 'Golf Hub Page Created',
  },
  {
    value: RegistrationFilterTypes.GOLF_HUB_PUBLISHED,
    label: 'Golf Hub Page Published',
  },
  {
    value: RegistrationFilterTypes.GOLF_HUB_NOT_CREATED,
    label: 'Golf Hub Page Not Created',
  },
]

const REGISTRATION_OPTIONS_VALUES = [
  RegistrationFilterTypes.OPEN,
  RegistrationFilterTypes.WILL_OPEN,
  RegistrationFilterTypes.OPEN_FOR_INVITATION,
  RegistrationFilterTypes.OPEN_FOR_MEMBERSHIP,
  RegistrationFilterTypes.CLOSED,
  RegistrationFilterTypes.WAITLIST_NOT_EMPTY,
  RegistrationFilterTypes.PENDING_LIST_NOT_EMPTY,
]

const GOLF_HUB_OPTIONS_VALUES = [
  RegistrationFilterTypes.GOLF_HUB_CREATED,
  RegistrationFilterTypes.GOLF_HUB_PUBLISHED,
  RegistrationFilterTypes.GOLF_HUB_NOT_CREATED,
]

export default RegistrationFilter
